export default __webpack_public_path__ + "static/media/product_hunt_clone.da9eb272.webp";